exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".graph-pe2-container{\n    background-color: white;\n    /* width:100%; */\n    width:1060px;\n    min-height:40px;\n    border-radius:5px;\n    padding:10px;\n    padding-top:20px;\n    margin-top:20px;\n    margin-right:7px;\n    position:absolute;\n    top:2065px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/graph-pe2/graph-pe2.component.css
// module id = ../../../../../src/app/components/graph-pe2/graph-pe2.component.css
// module chunks = main